"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/da-DK.ts
var da_DK_exports = {};
__export(da_DK_exports, {
  AG_CHARTS_LOCALE_DA_DK: () => AG_CHARTS_LOCALE_DA_DK
});
module.exports = __toCommonJS(da_DK_exports);
var AG_CHARTS_LOCALE_DA_DK = {
  ariaAnnounceChart: "diagram, ${seriesCount}[number] serier",
  ariaAnnounceFlowProportionLink: "link ${index} af ${count}, fra ${from} til ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "node ${index} af ${count}, ${description}",
  ariaAnnounceGaugeChart: "m\xE5lerdiagram, ${caption}",
  ariaAnnounceHierarchyChart: "hierarkisk diagram, ${caption}",
  ariaAnnounceHierarchyDatum: "niveau ${level}[number], ${count}[number] b\xF8rn, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Tryk p\xE5 mellemrumstasten eller Enter for at skifte synlighed",
  ariaLabelAddHorizontalLine: "Tilf\xF8j vandret linje",
  ariaLabelAnnotationOptionsToolbar: "Annotationmuligheder",
  ariaLabelAnnotationSettingsDialog: "Anm\xE6rkningsindstillinger",
  ariaLabelColorPicker: "Farvev\xE6lger",
  ariaLabelFinancialCharts: "Finansielle diagrammer",
  ariaLabelLegend: "Forklaring",
  ariaLabelLegendItem: "${label}, Legend element ${index}[number] af ${count}[number]",
  ariaLabelLegendItemUnknown: "Ukendt element i legenden",
  ariaLabelLegendPageNext: "N\xE6ste legendeside",
  ariaLabelLegendPagePrevious: "Forrige legenda-side",
  ariaLabelLegendPagination: "Legend paginering",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "R\xE6kkevidde",
  ariaLabelRangesToolbar: "Omr\xE5der",
  ariaLabelSettingsTabBar: "Indstillinger",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] til ${max}[percent0to2dp]",
  contextMenuDownload: "Download",
  contextMenuPanToCursor: "Panorer hertil",
  contextMenuToggleOtherSeries: "Skift Andre Serier",
  contextMenuToggleSeriesVisibility: "Skift synlighed",
  contextMenuZoomToCursor: "Zoom til her",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Dato og Pris",
  dialogHeaderDateRange: "Datointerval",
  dialogHeaderFibonacciRange: "Fib Tilbagef\xF8rsel",
  dialogHeaderLine: "Linje",
  dialogHeaderPriceRange: "Prisinterval",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Justering",
  dialogInputColorPicker: "Farve",
  dialogInputColorPickerAltText: "Tekstfarve",
  dialogInputExtendAbove: "Udvid over",
  dialogInputExtendBelow: "Forl\xE6ng nedenfor",
  dialogInputExtendChannelEnd: "Forl\xE6ng kanalende",
  dialogInputExtendChannelStart: "Forl\xE6ng kanalstart",
  dialogInputExtendLeft: "Udvid til venstre",
  dialogInputExtendLineEnd: "Forl\xE6ng linjens ende",
  dialogInputExtendLineStart: "Forl\xE6ng linjestart",
  dialogInputExtendRight: "Udvid til h\xF8jre",
  dialogInputFibonacciBands: "B\xE5nd",
  dialogInputFibonacciBandsAltText: "Fibonacci-b\xE5nd",
  dialogInputFillColorPicker: "Udfyld",
  dialogInputFillColorPickerAltText: "Fyldfarve",
  dialogInputFontSize: "St\xF8rrelse",
  dialogInputFontSizeAltText: "Skrifttypest\xF8rrelse",
  dialogInputLineStyle: "Streg",
  dialogInputPosition: "Position",
  dialogInputReverse: "Omvendt",
  dialogInputShowFill: "Vis udfyldning",
  dialogInputStrokeWidth: "V\xE6gt",
  dialogInputStrokeWidthAltText: "Linjev\xE6gt",
  iconAltTextAlignCenter: "Centr\xE9r",
  iconAltTextAlignLeft: "Venstre",
  iconAltTextAlignRight: "H\xF8jre",
  iconAltTextClose: "Luk",
  iconAltTextLineStyleDashed: "Lang-stiplet",
  iconAltTextLineStyleDotted: "Kort-stiplet",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "Bund",
  iconAltTextPositionCenter: "Centreret",
  iconAltTextPositionTop: "Top",
  inputTextareaPlaceholder: "Tilf\xF8j tekst",
  measurerDateRangeBars: "${value}[number] bj\xE6lker",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "Indl\xE6ser data...",
  overlayNoData: "Ingen data at vise",
  overlayNoVisibleSeries: "Ingen synlige serier",
  overlayUnsupportedBrowser: "Uforenelig browserversion. Opdater venligst din browser.",
  seriesHistogramTooltipCount: "${yName} (antal)",
  seriesHistogramTooltipFrequency: "Frekvens",
  seriesHistogramTooltipMean: "${yName} (gennemsnit)",
  seriesHistogramTooltipSum: "${yName} (sum)",
  toolbarAnnotationsArrow: "Pil",
  toolbarAnnotationsArrowDown: "Pil ned",
  toolbarAnnotationsArrowUp: "Pil Op",
  toolbarAnnotationsCallout: "Opkald",
  toolbarAnnotationsClearAll: "Ryd alle",
  toolbarAnnotationsComment: "Kommentar",
  toolbarAnnotationsDatePriceRange: "Dato og Pris",
  toolbarAnnotationsDateRange: "Datointerval",
  toolbarAnnotationsDelete: "Slet",
  toolbarAnnotationsDisjointChannel: "Adskilt Kanal",
  toolbarAnnotationsDragHandle: "Tr\xE6k v\xE6rkt\xF8jslinje",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Tilbagef\xF8rsel",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib-trendbaseret",
  toolbarAnnotationsFillColor: "Fyldfarve",
  toolbarAnnotationsHorizontalLine: "Vandret linje",
  toolbarAnnotationsLineAnnotations: "Trendlinjer",
  toolbarAnnotationsLineColor: "Linjefarve",
  toolbarAnnotationsLineStrokeWidth: "Linje penselbredde",
  toolbarAnnotationsLineStyle: "Linjestil",
  toolbarAnnotationsLock: "L\xE5s",
  toolbarAnnotationsMeasurerAnnotations: "M\xE5lere",
  toolbarAnnotationsNote: "Noter",
  toolbarAnnotationsParallelChannel: "Parallel kanal",
  toolbarAnnotationsPriceRange: "Prisklasse",
  toolbarAnnotationsQuickDatePriceRange: "M\xE5l",
  toolbarAnnotationsSettings: "Indstillinger",
  toolbarAnnotationsShapeAnnotations: "Pile",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Tekstantm\xE6rkninger",
  toolbarAnnotationsTextColor: "Tekstfarve",
  toolbarAnnotationsTextSize: "Tekstst\xF8rrelse",
  toolbarAnnotationsTrendLine: "Trendlinje",
  toolbarAnnotationsUnlock: "L\xE5s op",
  toolbarAnnotationsVerticalLine: "Lodret linje",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\xE5ned",
  toolbarRange1Year: "1\xC5r",
  toolbarRange1YearAria: "1 \xE5r",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 m\xE5neder",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 m\xE5neder",
  toolbarRangeAll: "Alle",
  toolbarRangeAllAria: "Alle",
  toolbarRangeYearToDate: "\xC5TD",
  toolbarRangeYearToDateAria: "\xC5r til dato",
  toolbarSeriesTypeCandles: "Stearinlys",
  toolbarSeriesTypeDropdown: "Diagramtype",
  toolbarSeriesTypeHighLow: "H\xF8j Lav",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Hule Stearinlys",
  toolbarSeriesTypeLine: "Linje",
  toolbarSeriesTypeLineWithMarkers: "Linje med mark\xF8rer",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Trin Linje",
  toolbarZoomPanEnd: "Pan til slutningen",
  toolbarZoomPanLeft: "Panorer til venstre",
  toolbarZoomPanRight: "Panor\xE9r til h\xF8jre",
  toolbarZoomPanStart: "Pan til starten",
  toolbarZoomReset: "Nulstil zoom",
  toolbarZoomZoomIn: "Zoom ind",
  toolbarZoomZoomOut: "Zoom ud",
  tooltipPaginationStatus: "${index}[number] af ${count}[number]"
};
//# sourceMappingURL=da-DK.cjs.js.map
